// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app/js/chunk" + chunkId + "." + "5dcf81332e2f7cf5" + ".js";
};